{
  "es": {
    "appModal": {
      "messages": {
        "confirm": {
          "dirty": "Tienes cambios sin guardar que se perderán."
        }
      }
    }
  }
}
